import { Button, Flex, type Sizes } from "@aws-amplify/ui-react"
import React from "react"
import { Link, useNavigate } from "react-router-dom"
import { FaPenToSquare, FaRegEye, FaRegStar, FaStar } from "react-icons/fa6"

export const imageHash = (
  hashSeed: number,
  uuid: string,
  N: number = 0
): number => {
  let x = hashSeed
  uuid.split("-").forEach((segment) => (x ^= Number.parseInt(segment, 16)))
  x = Math.abs(x)
  return N ? x % N : x
}

export enum StarStates {
  hidden = "hidden",
  empty = "empty",
  filled = "filled",
}
interface ListItemProps {
  className?: string
  title: string | React.ReactNode
  href?: string
  imageSrc: string
  details: string | React.ReactNode
  size?: Sizes
  starState?: StarStates
  hasViewButton?: boolean
  hasEditButton?: boolean
  viewButtonIcon?: React.ReactNode
}
export const ListItem = ({
  href,
  title,
  imageSrc,
  className,
  details,
  size = "large",
  starState = StarStates.hidden,
  hasViewButton = true,
  hasEditButton = false,
  viewButtonIcon = <FaRegEye />,
}: ListItemProps) => {
  const navigate = useNavigate()
  const isLarge = size === "large"
  const buttonFlexClasses = isLarge ? "!flex-col" : ""
  const firstColumnWidth = isLarge ? "108px" : "56px"
  let lastColumnWidthPx = 0
  if (hasViewButton || hasEditButton) {
    if (hasViewButton && hasEditButton) {
      lastColumnWidthPx = isLarge ? 40 : 40 + 16 + 40
    } else {
      lastColumnWidthPx = 40
    }
  }

  return (
    <div
      className={`grid grid-cols-4 grid-rows-2 w-full list-item-grid ${className} ${size.toString()} !cursor-pointer`}
      style={{
        gridTemplateColumns: `${firstColumnWidth} 0.5rem 1fr ${lastColumnWidthPx}px`,
        gridTemplateRows: "1lh auto",
      }}
      onClick={href ? () => navigate(href, { replace: false }) : undefined}
    >
      <div
        className="img row-span-full"
        style={{ backgroundImage: `url('${imageSrc}')` }}
      />

      <div className="col-start-3 col-span-1 info mb-2 truncate">
        <div className="title truncate">
          {title}
          {starState === StarStates.hidden ? (
            ""
          ) : (
            <>
              &nbsp;
              {starState === StarStates.empty ? (
                <FaRegStar
                  className="fav"
                  onClick={(e) => {
                    e.stopPropagation()
                    // alert('starClick')
                  }}
                />
              ) : (
                <FaStar
                  className="fav is-fav"
                  onClick={(e) => {
                    e.stopPropagation()
                    // alert('starClick')
                  }}
                />
              )}
            </>
          )}
        </div>
      </div>

      <div className="col-start-3 col-span-2 row-start-2 details">
        {details}
      </div>

      {(hasViewButton || hasEditButton) && (
        <div className="col-start-4 row-start-1 row-span-full">
          <Flex className={buttonFlexClasses}>
            {hasViewButton && href && (
              <Link to={href} onClick={(e) => e.stopPropagation()}>
                <Button className="button-view has-icon">
                  <span role="img" aria-label="Ansehen">
                    {viewButtonIcon}
                  </span>
                </Button>
              </Link>
            )}
            {/* todo: css class button-view is incorrect ; button-edit has wrong colors */}
            {hasEditButton && href && (
              <Link to={`${href}/edit`} onClick={(e) => e.stopPropagation()}>
                <Button className="button-view has-icon">
                  <span role="img" aria-label="Bearbeiten">
                    <FaPenToSquare />
                  </span>
                </Button>
              </Link>
            )}
          </Flex>
        </div>
      )}
    </div>
  )
}
